<div class="input-container">
  <label>
    {{label}}
    <div class="textarea-wrapper">
      <textarea #textarea [class.invalid]="control!.touched && control!.invalid" [placeholder]="placeholder" [formControl]="control" [ngClass]="size" (focus)="handleFocus()" (blur)="handleBlur()"></textarea>
      <app-button *ngIf="showActionButton && textarea.value.length === 0" [text]="actionButtonText" [border]="'round'" [style]="'outlined'" [size]="'small'" (clickEvent)="handleActionClick()"></app-button>
    </div>
    <span *ngIf="control?.touched && !isFocused && control?.errors" class="validation-message">
      <ng-container *ngIf="control!.errors!['required']">Das Feld darf nicht leer sein</ng-container>
      <ng-container *ngIf="control!.errors!['minlength']">Die Länge des Textes muss mindestens {{ control!.errors!['minlength'].requiredLength }} Zeichen lang sein</ng-container>
    </span>
  </label>
</div>